import { Button, Typography, UserTextRenderer } from "matsuri-ui"
import { css } from "@emotion/react"
import { isYoutubeLink } from "./isYoutubeLink"
import { useTranslation } from "@/hooks/useTranslation"

export const PositionOfGarbageDumpFormPrivateLodgingAndKeyNumber = ({
    value
}: {
    value?: string
}) => {
    const { t } = useTranslation()
    // 空文字/値なしの場合、ハイフンを表示
    if (!value) return <Typography>-</Typography>

    if (isYoutubeLink(value)) {
        return (
            <Button
                target="_blank"
                rel="noopener noreferrer"
                as="a"
                fullWidth
                variant="outlined"
                color="primary"
                href={value}
                css={css`
                    margin-top: 8px;
                `}
            >
                {t("動画で確認する")}
            </Button>
        )
    }
    return (
        <Typography>
            <UserTextRenderer>{value}</UserTextRenderer>
        </Typography>
    )
}
